import { useState } from "react";

export type TabMode = 'wait' | 'place' | 'sitting';

export const useMobileIndex = () => {

  const [ tabMode, setTabMode ] = useState<TabMode>('place')

  return {
    tabMode,
    setTabMode
  }
}